import { vDriveDeliveryStatus } from './api/wallet.types';

/**
 * What sends an automatic message: a delivery reaching a status, the customer's ETA moving
 * later, or the food-rating request 15 minutes after delivery. There can be one `etaIncreased`
 * and one `foodRating` message, and neither has a status.
 */
export enum IncidentMessageType {
  status = 'status',
  etaIncreased = 'etaIncreased',
  foodRating = 'foodRating',
}

export interface IncidentMessage {
  id: number;
  type: IncidentMessageType;
  /** `null` for an `etaIncreased` or `foodRating` message. */
  status: vDriveDeliveryStatus | null;
  message: string;
  enabled: boolean;
}

export interface CreateIncidentMessageDto {
  /** The backend defaults a missing type to `status`. */
  type?: IncidentMessageType;
  /** Required for a status message, never sent for the other types. */
  status?: vDriveDeliveryStatus;
  message: string;
  enabled: boolean;
}

export type UpdateIncidentMessageDto = Partial<CreateIncidentMessageDto>;
